import { List } from 'immutable'
import { Updater, AsyncState } from 'widgets-for-react'
import {
  ActualityPageData,
  PageResult,
  SubscriptionData
} from '../sharepointPageApi/types/pageData'
import { AllCasesBlockState } from './allCasesBlock/allCasesBlockState'
import { AllCasesBlock } from './allCasesBlock/allCasesBlockWidget'
import { AllCourseCategoriesBlockState } from './allCourseCategoriesBlock/allCourseCategoriesBlockState'
import { AllCourseCategoriesBlock } from './allCourseCategoriesBlock/allCourseCategoriesBlockWidget'

import { AdvertisementBlock } from './advertisementBlockLayout'
import { AllCourseGroupsBlockState } from './allCourseGroupsBlock/allCourseGroupsBlockState'
import { AllCourseGroupsBlock } from './allCourseGroupsBlock/allCourseGroupsBlockWidget'
import { AllNewsBlock } from './allNewsBlock/allNewsBlockWidget'
import { AllSubscriptionsBlock } from './allSubscriptionsBlock/allSubscriptionsBlockWidget'
import { ChildCourseGroupsBlockState } from './childCourseGroupsBlock/childCourseGroupsBlockState'
import { ChildCourseGroupsBlock } from './childCourseGroupsBlock/childCourseGroupsBlockWidget'
import { ChildDossiersBlockState } from './childDossiersBlock/childDossiersBlockState'
import { ChildDossiersBlock } from './childDossiersBlock/childDossiersBlockWidget'
import { ContactPersonBlockState } from './contactPersonBlock/contactPersonBlockState'
import { CourseDetailsState } from './courseDetailsBlock/courseDetailsBlockState'
import { CourseDetailsBlock } from './courseDetailsBlock/courseDetailsBlockWidget'
import { CourseOverviewBlock } from './courseOverview/courseOverviewWidget'
import { CourseSearchBarState } from './CourseSearchBar/courseSearchBarState'
import { CourseSearchBarBlock } from './CourseSearchBar/courseSearchBarWidget'
import { CtaBlock } from './ctaBlockLayout'
import { DossierArticlesBlockState } from './dossierArticlesBlock/dossierArticlesBlockState'
import { DossierArticlesBlock } from './dossierArticlesBlock/dossierArticlesBlockWidget'
import { DownloadsBlock } from './downloadsBlockLayout'
import { AllEventsBlockState } from './eventOverviewBlock/allEventsBlockState'
import { AllEventsBlock } from './eventOverviewBlock/allEventsBlockWidget'
import { ExpandBlockState } from './expandBlock/expandBlockState'
import { ExpandBlock } from './expandBlock/expandBlockWidget'
import { FeaturedContentBlock } from './featuredContentBlockLayout'
import { IframeBlock } from './iframeBlockLayout'
import { LinkBlock } from './linkBlockLayout'
import { LinkGridBlock } from './linkGridBlockLayout'
import { MediaBlock } from './mediaBlockLayout'
import { QuoteBlock } from './quoteBlockLayout'
import { RelatedActualitiesBlockState } from './relatedActualitiesBlock/relatedActualitiesBlockState'
import { RelatedContentBlockState } from './relatedContentBlock/relatedContentBlockState'
import { RelatedContentBlock } from './relatedContentBlock/relatedContentBlockWidget'
import { TextBlock } from './textBlockLayout'
import { TextImageBlock } from './textImageBlockLayout'
import { KnowledgeSearchBarState } from './KnowledgeSearchBar/knowledgeSearchBarState'
import { KnowledgeSearchBarBlock } from './KnowledgeSearchBar/knowledgeSearchBarWidget'
import { ActualitySearchBarBlock } from './ActualitySearchBar/actualitySearchBarWidget'
import { ActualitySearchBarState } from './ActualitySearchBar/actualitySearchBarState'
import { LogoSliderBlock } from './LogoSlider/logoSliderWidget'
import { LogoSliderState } from './LogoSlider/logoSliderState'
import { CourseOverviewBlockState } from './courseOverview/courseOverviewState'
import { EventDetailsState } from './eventDetailsBlock/eventDetailsBlock.state'
import { EventDetailsBlock } from './eventDetailsBlock/eventDetailsBlock.widget'


export type BlocksState = List<Block>

export type Block =
  | ({
    kind: 'ctaBlock'
  } & CtaBlock)
  | ({
    kind: 'expandBlock'
  } & ExpandBlock)
  | ({
    kind: 'featuredContentBlock'
  } & FeaturedContentBlock)
  | ({
    kind: 'linkBlock'
  } & LinkBlock)
  | ({
    kind: 'linkGridBlock'
  } & LinkGridBlock)
  | ({
    kind: 'mediaBlock'
  } & MediaBlock)
  | ({
    kind: 'quoteBlock'
  } & QuoteBlock)
  | ({
    kind: 'textImageBlock'
  } & TextImageBlock)
  | ({
    kind: 'textBlock'
  } & TextBlock)
  | ({
    kind: 'relatedContentBlock'
  } & RelatedContentBlock)
  | ({
    kind: 'childDossiersBlock'
  } & ChildDossiersBlock)
  | ({
    kind: 'dossierArticlesBlock'
  } & DossierArticlesBlock)
  | ({
    kind: 'courseOverviewBlock'
  } & CourseOverviewBlock)
  | ({
    kind: 'allCourseGroupsBlock'
  } & AllCourseGroupsBlock)
  | ({
    kind: 'allCourseCategoriesBlock'
  } & AllCourseCategoriesBlock)
  | ({
    kind: 'allCasesBlock'
  } & AllCasesBlock)
  | ({
    kind: 'allSubscriptionsBlock'
  } & AllSubscriptionsBlock)
  | ({
    kind: 'allNewsBlock'
  } & AllNewsBlock)
  | ({
    kind: 'allEventsBlock'
  } & AllEventsBlock)
  | ({
    kind: 'childCourseGroupsBlock'
  } & ChildCourseGroupsBlock)
  | ({
    kind: 'courseDetailsBlock'
  } & CourseDetailsBlock)
  | ({
    kind: 'eventDetailsBlock'
  } & EventDetailsBlock)
  | ({
    kind: 'downloadsBlock'
  } & DownloadsBlock)
  | {
    kind: 'incompanyBlock'
  }
  | ({
    kind: 'relatedActualitiesBlock'
  } & RelatedActualitiesBlock)
  | ({
    kind: 'contactPersonBlock'
  } & ContactPersonBlock)
  | ({
    kind: 'knowledgeSearchBar'
  } & KnowledgeSearchBarBlock)
  | ({
    kind: 'iframe'
  } & IframeBlock)
  | ({
    kind: 'courseSearchBar'
  } & CourseSearchBarBlock)
  | ({
    kind: 'actualitySearchBar'
  } & ActualitySearchBarBlock)
  | ({
    kind: 'logoSlider'
  } & LogoSliderBlock)
  | ({
      kind: 'linkGridBlockNew'
    } & LinkGridBlock)
  | ({
      kind: 'advertisementBlock'
    } & AdvertisementBlock)
  | {
    kind: 'noBlock'
  }

export type SVGIconProps = {
  width: string
  height: string
}

export type ActionProps = {
  url: string
  title: string
  SVGIcon?: SVGIconProps
}

export type InviewProps = {
  threshold?: number
  triggerOnce?: boolean
}

export type RelatedActualitiesBlock = {
  index: number
  inview?: InviewProps
  relatedActualitiesState: RelatedActualitiesBlockState
}

export type ContactPersonBlock = {
  index: number
  inview?: InviewProps
  contactPersonBlockState: ContactPersonBlockState
}

export const blocksStateUpdaters = {
  blockUpdater: (index: number) => (updater: Updater<Block>) => (
    currentState: List<Block>
  ): List<Block> => {
    const blockStateItem = currentState.get(index)
    return blockStateItem
      ? currentState.set(index, updater(blockStateItem))
      : currentState
  },
  expandBlockStateUpdater: (updater: Updater<ExpandBlockState>) => (
    currentState: Block
  ): Block =>
    currentState.kind === 'expandBlock'
      ? {
        ...currentState,
        expandBlockState: updater(currentState.expandBlockState)
      }
      : currentState,
  relatedContentBlockStateUpdater: (
    updater: Updater<RelatedContentBlockState>
  ) => (currentState: Block): Block =>
      currentState.kind === 'relatedContentBlock'
        ? {
          ...currentState,
          relatedContentBlockState: updater(
            currentState.relatedContentBlockState
          )
        }
        : currentState,
  childDossiersBlockStateUpdater: (
    updater: Updater<ChildDossiersBlockState>
  ) => (currentState: Block): Block =>
      currentState.kind == 'childDossiersBlock'
        ? {
          ...currentState,
          childrenState: updater(currentState.childrenState)
        }
        : currentState,
  dossierArticlesBlockStateUpdater: (
    updater: Updater<DossierArticlesBlockState>
  ) => (currentState: Block): Block =>
      currentState.kind == 'dossierArticlesBlock'
        ? {
          ...currentState,
          articlesState: updater(currentState.articlesState)
        }
        : currentState,
  courseGroupCoursesBlockStateUpdater: (
    updater: Updater<CourseOverviewBlockState>
  ) => (currentState: Block): Block =>
      currentState.kind == 'courseOverviewBlock'
        ? {
          ...currentState,
          coursesState: updater(currentState.coursesState)
        }
        : currentState,
  allCourseGroupsBlockStateUpdater: (
    updater: Updater<AllCourseGroupsBlockState>
  ) => (currentState: Block): Block =>
      currentState.kind == 'allCourseGroupsBlock'
        ? {
          ...currentState,
          courseGroupsState: updater(currentState.courseGroupsState)
        }
        : currentState,
  allCourseCategoriesBlockStateUpdater: (
    updater: Updater<AllCourseCategoriesBlockState>
  ) => (currentState: Block): Block =>
      currentState.kind == 'allCourseCategoriesBlock'
        ? {
          ...currentState,
          courseCategoriesState: updater(currentState.courseCategoriesState)
        }
        : currentState,
  allCasesBlockStateUpdater: (updater: Updater<AllCasesBlockState>) => (
    currentState: Block
  ): Block =>
    currentState.kind == 'allCasesBlock'
      ? {
        ...currentState,
        casesState: updater(currentState.casesState)
      }
      : currentState,
  allSubscriptionsBlockStateUpdater: (
    updater: Updater<AsyncState<SubscriptionData[]>>
  ) => (currentState: Block): Block =>
      currentState.kind == 'allSubscriptionsBlock'
        ? {
          ...currentState,
          subscriptionsState: updater(currentState.subscriptionsState)
        }
        : currentState,
  allNewsBlockStateUpdater: (
    updater: Updater<AsyncState<PageResult<ActualityPageData>>>
  ) => (currentState: Block): Block =>
      currentState.kind == 'allNewsBlock'
        ? {
          ...currentState,
          newsState: updater(currentState.newsState)
        }
        : currentState,
  allEventsBlockStateUpdater: (updater: Updater<AllEventsBlockState>) => (
    currentState: Block
  ): Block =>
    currentState.kind == 'allEventsBlock'
      ? {
        ...currentState,
        eventsState: updater(currentState.eventsState)
      }
      : currentState,
  childCourseGroupsBlockStateUpdater: (
    updater: Updater<ChildCourseGroupsBlockState>
  ) => (currentState: Block): Block =>
      currentState.kind == 'childCourseGroupsBlock'
        ? {
          ...currentState,
          courseGroupsState: updater(currentState.courseGroupsState)
        }
        : currentState,
  courseDetailsBlockStateUpdater: (updater: Updater<CourseDetailsState>) => (
    currentState: Block
  ): Block =>
    currentState.kind == 'courseDetailsBlock'
      ? {
        ...currentState,
        state: updater(currentState.state)
      }
      : currentState,
  relatedActualitiesBlockStateUpdater: (
    updater: Updater<RelatedActualitiesBlockState>
  ) => (currentState: Block): Block =>
      currentState.kind == 'relatedActualitiesBlock'
        ? {
          ...currentState,
          relatedActualitiesState: updater(currentState.relatedActualitiesState)
        }
        : currentState,
  contactPersonBlockStateUpdater: (
    updater: Updater<ContactPersonBlockState>
  ) => (currentState: Block): Block =>
      currentState.kind == 'contactPersonBlock'
        ? {
          ...currentState,
          contactPersonBlockState: updater(currentState.contactPersonBlockState)
        }
        : currentState,
  courseSearchBarBlockUpdater: (
    updater: Updater<CourseSearchBarState>
  ) => (currentState: Block): Block =>
      currentState.kind == 'courseSearchBar'
        ? {
          ...currentState,
          courseSearchBarState: updater(currentState.courseSearchBarState)
        }
        : currentState,
  knowledgeSearchBarBlockUpdater: (
    updater: Updater<KnowledgeSearchBarState>
  ) => (currentState: Block): Block =>
      currentState.kind == 'knowledgeSearchBar'
        ? {
          ...currentState,
          knowledgeSearchBarState: updater(currentState.knowledgeSearchBarState)
        }
        : currentState,
  actualitySearchBarBlockUpdater: (
    updater: Updater<ActualitySearchBarState>
  ) => (currentState: Block): Block =>
      currentState.kind == 'actualitySearchBar'
        ? {
          ...currentState,
          actualitySearchBarState: updater(currentState.actualitySearchBarState)
        }
        : currentState,
  logoSliderBlockUpdater: (
    updater: Updater<LogoSliderState>
  ) => (currentState: Block): Block =>
      currentState.kind == 'logoSlider'
        ? {
          ...currentState,
          logoSliderState: updater(currentState.logoSliderState)
        }
        : currentState,
  eventDetailsBlockStateUpdater: (updater: Updater<EventDetailsState>) => (
    currentState: Block
  ): Block =>
    currentState.kind == 'eventDetailsBlock'
      ? {
        ...currentState,
        state: updater(currentState.state)
      }
      : currentState,
}
